import React, { useState, useEffect, Fragment } from 'react';
import LPTooltip from './LPTooltip';

const roles_top = [
  { key: 'Top', icon: require('../assets/Positions/Top.png') },
  { key: 'Jungle', icon: require('../assets/Positions/Jungle.png') },
  { key: 'Mid', icon: require('../assets/Positions/Mid.png') },
];
const roles_bottom = [
  { key: 'ADC', icon: require('../assets/Positions/ADC.png') },
  { key: 'Support', icon: require('../assets/Positions/Support.png') },
];
const allRoles = [...roles_top, ...roles_bottom];

function RoleSelector({ selectedRoles, toggleRole }) {
  const [isWrapped, setIsWrapped] = useState(
    typeof window !== 'undefined' ? window.innerWidth < 1170 : false
  );

  useEffect(() => {
    const handleResize = () => setIsWrapped(window.innerWidth < 1170);
    window.addEventListener('resize', handleResize);
    // Initial check
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const baseBtnClass =
  'group flex-none flex items-center justify-center rounded-md transition-shadow transition-opacity duration-200 ease-out hover:shadow-[0_0_4px_rgba(0,186,255,0.4)] hover:bg-white/5';

  return (
    <div>
      <div className="flex items-center mb-1">
        <p className="text-sm text-[var(--secondary-text)]">Preferred Roles</p>
        <span className="ml-2 flex-shrink-0">
          <LPTooltip tooltipText="This will help the coach understand your playstyle." />
        </span>
      </div>

      {!isWrapped ? (
        // Single centered row, no wrapping
        <div className="flex flex-nowrap justify-center gap-2 overflow-x-auto">
          {allRoles.map(({ key, icon }) => (
            <button
              key={key}
              onClick={() => toggleRole(key)}
              aria-pressed={selectedRoles.includes(key)}
              className={`${baseBtnClass} ${
                selectedRoles.includes(key)
                  ? 'shadow-[0_0_6px_rgba(0,186,255,0.6)] bg-white/10'
                  : 'shadow-sm bg-transparent'
              }`}
            >
              <img src={icon} alt={`${key} Role Icon`} className="w-8 h-8" width={32} height={32} />
            </button>
          ))}
        </div>
      ) : (
        // Wrapped mode: two full-width centered rows
        <Fragment>
          <div className="w-full flex justify-center gap-2">
            {roles_top.map(({ key, icon }) => (
              <button
                key={key}
                onClick={() => toggleRole(key)}
                aria-pressed={selectedRoles.includes(key)}
                className={`${baseBtnClass} ${
                  selectedRoles.includes(key)
                    ? 'shadow-[0_0_6px_rgba(0,186,255,0.6)] bg-white/10'
                    : 'shadow-sm bg-transparent'
                }`}
              >
                <img src={icon} alt={`${key} Role Icon`} className="w-8 h-8" width={32} height={32} />
              </button>
            ))}
          </div>
          <div className="w-full flex justify-center gap-2">
            {roles_bottom.map(({ key, icon }) => (
              <button
                key={key}
                onClick={() => toggleRole(key)}
                aria-pressed={selectedRoles.includes(key)}
                className={`${baseBtnClass} ${
                  selectedRoles.includes(key)
                    ? 'shadow-[0_0_6px_rgba(0,186,255,0.6)] bg-white/10'
                    : 'shadow-sm bg-transparent'
                }`}
              >
                <img src={icon} alt={`${key} Role Icon`} className="w-8 h-8" width={32} height={32} />
              </button>
            ))}
          </div>
        </Fragment>
      )}
    </div>
  );
}

export default RoleSelector;
